import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { grey_900 } from '@fiverr-private/sass/helpers/index';
import { getLanguageCodeLevelKey } from './utils';

/** @type {React.FC<{className?: string; languages: import('../../../../types').Language[]}>} */
const Languages = ({ languages }) => (
    <div>
        <div className="text-semi-bold tbody-5 m-b-16">
            <I18n k={'freelancer_page.details.i_speak'} />
        </div>
        <div>
            {languages.map(({ code, level }) => (
                <div className="m-b-16" key={code}>
                    <span>
                        <I18n k={`languages.codes.${code.toLowerCase()}`} />
                    </span>
                    <span className="m-l-16" style={{ color: grey_900 }}>
                        <I18n k={getLanguageCodeLevelKey(level)} />
                    </span>
                </div>
            ))}
        </div>
    </div>
);

export default Languages;
